import { observable, action } from "mobx";
import axios from "axios";

class IndexStore {
  @observable public apkFile: any;
  @observable public docDetail: {};

  @action public async getApk() {
    const { data } = await axios.get("v1/app/getApk");
    this.apkFile = data;
    return data;
  }

  @action public async getDocDetail(id: number) {
    this.docDetail = ''
    const { data } = await axios.get(`/v1/docmanage/detail/${id}`);
    if (data.code === 0) {
      this.docDetail = data.data;
    }
    return data;
  }
}
export default IndexStore;



// WEBPACK FOOTER //
// ./src/stores/IndexStore.ts